import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";
import { CommonRequest } from "@/types/http";

async function create(data: any): Promise<CommonRequest<any>> {
  const response = await http.postData("/catatan-paska-sedasi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function update(id: number, data: any): Promise<CommonRequest<any>> {
  const response = await http
    .putData(`/catatan-paska-sedasi/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getByRegister(
  register_id: string | number
): Promise<CommonRequest<any[]>> {
  const response = await http
    .getData(`/register/${register_id}/catatan-paska-sedasi`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function find(id: number): Promise<CommonRequest<any>> {
  const response = await http
    .getData(`/catatan-paska-sedasi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function destroy(id: number): Promise<CommonRequest<undefined>> {
  const response = await http
    .deleteData(`/catatan-paska-sedasi/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function signDokter(id: number, data: any) {
  const response = await http
    .putData(`/catatan-paska-sedasi/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function print(id: number) {
  window.open(`${http.getAPI()}/catatan-paska-sedasi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  signDokter,
  print
};
